import React from 'react';
import styled from 'styled-components';

const RichText = styled.div`
  word-break: break-word;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;

    + p {
      margin-top: 1rem;
    }
  }

  h6 {
    font-size: inherit;
  }

  p {
    margin: 0 0 1.5rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  a {
    &:hover {
      text-decoration: underline;
    }
  }

  .underline {
    text-decoration: underline;
  }

  .right-align {
    display: block;
    text-align: right;
  }

  .center-align {
    display: block;
    text-align: center;
  }
`;

export default props => {
  if (!props.content) {
    return null;
  }
  const markup = { __html: props.content };
  return <RichText className="richText" dangerouslySetInnerHTML={markup} />;
};
